import { createSceneReducer } from './reducers-util';
import notificationsDataReducer from './notifications.data';
import notificationsUiReducer from './notifications.ui';

export default createSceneReducer(
  notificationsDataReducer,
  notificationsUiReducer
);
